import { createRef } from "react";
import { TableSearchFilter } from "../TableSearchFilter";
import { SearchFilterButton } from "./SearchFilterButton";

export const GetSearchFilterProps = ({
  setQueryParamFunction,
  queryParamValue,
  queryParamKey,
  customFilter,
}) => {
  const inputRef = createRef();

  const defaultFilterDropdown = ({ confirm }) => (
    <TableSearchFilter
      inputRef={inputRef}
      onReset={() => setQueryParamFunction(queryParamKey, undefined)}
      onSearch={(value) => setQueryParamFunction(queryParamKey, value)}
      confirm={confirm}
      defaultValue={queryParamValue}
    />
  );

  return {
    filterDropdown: customFilter
      ? ({ confirm }) => customFilter(confirm, inputRef)
      : defaultFilterDropdown,
    filterIcon: () => (
      <SearchFilterButton
        isActive={!!queryParamValue}
        data-test-id="project-search"
        isUserFilter={false}
      />
    ),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => inputRef.current?.focus(), 100);
        }
      },
    },
  };
};
